import { render, staticRenderFns } from "./ProofreadingPopup.vue?vue&type=template&id=adf4a0ca&scoped=true"
import script from "./ProofreadingPopup.vue?vue&type=script&lang=ts"
export * from "./ProofreadingPopup.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingPopup.vue?vue&type=style&index=0&id=adf4a0ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf4a0ca",
  null
  
)

export default component.exports